// extracted by mini-css-extract-plugin
module.exports = {"list":"XBBy1","row":"CF-1F","column":"_6zM42","links":"_4J3xq","action":"sodBJ"};